import { getFoundationConcreteVolume as o } from "./index22.js";
const r = (e) => o(e) * 2400;
export {
  r as getFoundationConcreteWeight
};
//# sourceMappingURL=index23.js.map
